import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { Formik } from 'formik';
import { Button } from 'components/ui_library/Button';
import { RadioGroup, useRadioState } from 'components/RadioGroup';
import { css } from '@linaria/core';
import { ComputeEntitySelector } from 'modules/Compute/Components/ComputeEntitySelector/ComputeEntitySelector';
import { useGenerateOptions } from 'modules/Compute/Components/ComputeEntitySelector/useGenerateOptions';
interface NodepoolCreationModalProps {
  onClose: () => void;
}
export const NodepoolCreationModal: React.FC<NodepoolCreationModalProps> = ({
  onClose
}) => {
  const router = useRouter();
  const [selectedCluster, setSelectedCluster] = useState<string | undefined>(undefined);

  // Create radio state for cluster selection
  const radioState = useRadioState({
    baseId: 'cluster-option',
    state: 'existing'
  });
  const handleContinue = () => {
    if (radioState.state === 'new') {
      // Redirect to cluster creation form
      router.push('/compute/create');
    } else if (radioState.state === 'existing' && selectedCluster) {
      // Redirect to nodepool creation with selected cluster
      router.push(`/compute/clusters/${selectedCluster}/nodepools/create`);
    }
    onClose();
  };
  const canContinue = radioState.state === 'new' || radioState.state === 'existing' && selectedCluster;
  const options = useGenerateOptions({
    entityType: 'cluster'
  });
  return <div className={modalStyles}>
      <div className="modal-content">
        <div className="description">Nodepools run inside clusters. Choose an existing one or create a new one first.</div>

        <div className="form-section">
          <div className="form-label">Where do you want to add this nodepool?</div>

          <div className="radio-group">
            <RadioGroup radio={radioState} options={[{
            value: 'new',
            label: 'New Cluster'
          }, {
            value: 'existing',
            label: 'Existing Cluster'
          }]} />
          </div>

          <div className="cluster-selector">
            <Formik initialValues={{}} onSubmit={() => {}}>
              <ComputeEntitySelector className={radioState.state === 'new' ? 'disabled' : ''} entityType="cluster" isDisabled={radioState.state === 'new'} name="clusterSelect" onSelect={newClusterId => setSelectedCluster(newClusterId)} options={options} placeholder="Choose an existing cluster" />
            </Formik>
          </div>
        </div>

        <div className="actions">
          <Button size="md" variant="tertiary" onClick={onClose}>
            Cancel
          </Button>
          <Button size="md" variant="primary" onClick={handleContinue} disabled={!canContinue}>
            Continue
          </Button>
        </div>
      </div>
    </div>;
};
const modalStyles = "odules__Compute__Components__NodepoolCreationModal__NodepoolCreationModal_tsx-modalStyles-m1n97i7n";

require("./NodepoolCreationModal.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./NodepoolCreationModal.tsx");